module.exports = __webpack_public_path__ + "assets/img/3.017b9210.png";